/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueList = {
    type: 'array',
    contains: {
        type: 'League',
    },
} as const;
